<script setup lang="ts">
import type { Order } from "@/schemas/order";

defineProps<{ order: Order }>();
</script>

<template>
  <ul>
    <li>
      Numéro de commande: <strong>{{ order.order_id }}</strong>
    </li>
    <li>
      Date: <strong>{{ date(order.timestamp) }}</strong>
    </li>
    <li>
      Courriel: <strong>{{ order.customer.billing.email }}</strong>
    </li>
    <li>
      Total: <strong>{{ currency(order.total_order) }}</strong>
    </li>
    <li>
      Moyen de paiement: <strong>{{ order.payment_method }}</strong>
    </li>
  </ul>
</template>
